import { FC, PropsWithChildren } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import useGlobalContext from '@context/GlobalContext/useGlobalContext'
import Loader from './Loader'

interface LoadingErrorProps {
  isLoading: boolean
  isError: boolean
  error?: {
    code: string
    message: string
  }
  // Optional message to show under the loader
  loadingMessage?: string
}

const LoadingError: FC<PropsWithChildren<LoadingErrorProps>> = ({
  children,
  isLoading,
  isError,
  error,
  loadingMessage,
}) => {
  const { pageHeight } = useGlobalContext()
  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: pageHeight,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'top',
          justifyContent: 'top',
          textAlign: 'center',
          p: 2,
        }}
      >
        <Loader />
        {loadingMessage && (
          <Typography variant="body1" sx={{ mt: 2 }}>
            {loadingMessage}
          </Typography>
        )}
      </Box>
    )
  }
  if (isError) {
    return (
      <Box sx={{ minHeight: pageHeight, p: 4 }}>
        <Typography variant={'h1'} color={'error'}>
          {error?.message || 'Looks like we hit a snag!'}
        </Typography>
      </Box>
    )
  }

  return <>{children}</>
}

export default LoadingError
